import { ConfirmationModal, IconAttention, useModal } from '@procurify/ui'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { useMutateUnlockCardAdmin } from '@webapp/modules/spending-cards/features/unlock-card-admin/models/useMutateUnlockCardAdmin'
import messages from './messages'

export const useUnlockCardAdminPresenter = () => {
  const modal = useModal()
  const intl = useProcurifyIntl()

  const { unlock } = useMutateUnlockCardAdmin()

  const showUnlockCardModal = async (
    externalId: string,
    onCardUnlocked: () => void = () => null
  ) => {
    await modal.showModal(ConfirmationModal, {
      open: true,
      icon: <IconAttention />,
      type: 'warning',
      header: intl.formatMessage(messages.modalTitle),
      content: intl.formatMessage(messages.modalContent),
      confirmButtonText: intl.formatMessage(messages.modalConfirmButton),
      handleDismiss: () => modal.hideModal(),
      onConfirm: async () => {
        try {
          await unlock({ externalId })

          toast.success({
            title: intl.formatMessage(messages.successToastMessage),
          })
          onCardUnlocked()
          modal.hideModal()
        } catch (error) {
          toast.error({
            title: intl.formatMessage(messages.errorToastMessage),
          })
        }
      },
    })
  }

  return {
    commands: {
      showUnlockCardModal,
    },
  }
}
